import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SphereMark = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 100 100" className={className} aria-hidden="true">
    <defs>
      <radialGradient id="osg" cx="35%" cy="35%" r="65%">
        <stop offset="0%" stopColor="#FFFFFF" />
        <stop offset="55%" stopColor="#C49A6C" />
        <stop offset="100%" stopColor="#2B3A42" />
      </radialGradient>
    </defs>
    <circle cx="50" cy="50" r="46" fill="url(#osg)" />
    <circle cx="50" cy="50" r="46" fill="none" stroke="#1A1A1A" strokeOpacity="0.15" />
  </svg>
);

export const Overline = ({ children, className = "" }) => (
  <span className={`overline ${className}`}>{children}</span>
);
